import * as React from "react";
import { IdPremiumType } from "../../constants/IdPremiumType";
import { IdStyles } from "../../less/IdStyles";
import { utilButton } from "../../utils/utilButton";
import { GridItemContainerDefault } from "../generic/common/GridItemContainerDefault";
import { GridItemContainerDefaultPremium } from "../generic/common/GridItemContainerDefaultPremium";
import { IconBuilding } from "../generic/common/icon-building/IconBuilding";
import { IdIconBuildingContext } from "../generic/common/icon-building/IdIconBuildingContext";
import { Icon } from "../generic/icon/Icon";
import { TextLocaValueProportional } from "../generic/text/TextLocaValueProportional";
var getItemCountInfo = function (maxAmount, existingCount) { return (React.createElement("div", { className: "building-item__text " + IdStyles.TextBoldAccent },
    React.createElement(TextLocaValueProportional, { available: existingCount, required: maxAmount }))); };
export var GridItemStoreItem = React.memo(function (_a) {
    var item = _a.item, onClick = _a.onClick, className = _a.className;
    var _b = item.balancing, packageIcon = _b.packageIcon, backgroundColor = _b.backgroundColor, buildingReward = _b.buildingReward, buildingRewardInfo = item.buildingRewardInfo;
    var GridItemComponent = GridItemContainerDefault;
    if (backgroundColor && backgroundColor === IdPremiumType.Blue) {
        GridItemComponent = GridItemContainerDefaultPremium;
    }
    var infoIcon = React.createElement(Icon, { icon: packageIcon, styleId: IdStyles.IconExtraLarge });
    if (buildingRewardInfo) {
        var stageId = buildingReward[0].stageId;
        var name = buildingRewardInfo.name;
        var buildingCountInfo = getItemCountInfo(buildingRewardInfo.maxAmount, item.buildingCount || 0);
        infoIcon = (React.createElement(React.Fragment, null,
            React.createElement(IconBuilding, { level: stageId, buildingName: name, context: IdIconBuildingContext.BuildItem }),
            buildingCountInfo));
    }
    var lockedClass = item.isLocked ? "locked" : "";
    return (React.createElement(GridItemComponent, { className: "" + className, onClick: function () { return utilButton.onClickWithSound(onClick); } },
        React.createElement("div", { className: "flex flex--guts h100 position-relative " + lockedClass }, infoIcon)));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/store/GridItemStoreItem.tsx
// module id = 2767
// module chunks = 3